// extracted by mini-css-extract-plugin
export var card = "posts-module--card--1xNpo";
export var tagWidth = "posts-module--tagWidth--1UjvB";
export var toread = "posts-module--toread--3QmIk";
export var post_link = "posts-module--post_link--3DF_f";
export var thumb = "posts-module--thumb--24pJ_";
export var post_title = "posts-module--post_title--2sUZK";
export var post_meta = "posts-module--post_meta--23L5p";
export var shadow = "posts-module--shadow--31FvS";
export var lang = "posts-module--lang--3d99F";